import { useLocation } from 'react-router-dom';
export function useTreatmentCost() {
  var _search$get;

  var location = useLocation();
  var search = new URLSearchParams(location.search);
  return Number((_search$get = search.get('cost')) !== null && _search$get !== void 0 ? _search$get : 0);
}
export function useMaxDownpayment(loanMinimum) {
  var treatmentCost = useTreatmentCost();
  return treatmentCost - loanMinimum;
}